export default "__VITE_ASSET__7bd94a82__"